/**
 * Підміна вигляду `<select>` на рівні JSX-рантайму (ч.965).
 *
 * ЧОМУ САМЕ ТУТ. Проєкт зібрано з `"jsx": "react-jsx"` — JSX компілюється
 * не у `React.createElement`, а у виклики `react/jsx-runtime`. Тому патч
 * `React.createElement` НЕ спрацював би (перевірено перед реалізацією).
 * Натомість `vite.config.ts` аліасить `react/jsx-runtime` і `react/jsx-dev-
 * runtime` на цей модуль: ми проксуємо оригінал і підміняємо ЛИШЕ тип
 * `'select'`. Решта елементів іде без змін.
 *
 * Підміняється ВИГЛЯД, а не поведінка: `SelectShim` лишає справжній
 * `<select>` у DOM (прихованим) з усіма props і `<option>`, тож
 * value/onChange/name/валідація/автотести працюють як раніше. Деталі —
 * у `installNiceSelect.tsx`.
 */
// eslint-disable-next-line import/no-unresolved
import * as runtime from 'react/jsx-runtime';

import { SelectShim } from './installNiceSelect';

type Fn = (type: unknown, props: unknown, key?: unknown) => unknown;

const swap = (fn: Fn): Fn => (type, props, key) =>
  fn(type === 'select' ? SelectShim : type, props, key);

export const Fragment = runtime.Fragment;
export const jsx = swap((runtime as unknown as { jsx: Fn }).jsx);
export const jsxs = swap((runtime as unknown as { jsxs: Fn }).jsxs);
export const jsxDEV = swap(
  ((runtime as unknown as { jsxDEV?: Fn }).jsxDEV
    ?? (runtime as unknown as { jsx: Fn }).jsx) as Fn,
);
